import { Resources } from "web_myplann/Infrastructure/Translations/Resources";
import { getContractRequiredMinimumRefinement } from "web_myplann/Portfolio/Forms/ContractShared/contractRequiredMinimum";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";
import { DateFormat } from "web_myplann/Shared/Utils/dateFormats";
import {
	type KeyFieldsLockOptions,
	lockableField,
} from "web_myplann/Shared/Validation/lockableField";
import { optionalDateAsString } from "web_myplann/Shared/Validation/optionalDateAsString";
import { refineDateOrder } from "web_myplann/Shared/Validation/refineDateOrder";
import { trimmedNullable } from "web_myplann/Shared/Validation/trimmedNullable";
import { ValidationLimits } from "web_myplann/Shared/Validation/validationLimits";
import { z } from "zod";

export const getLifeInsuranceFormSchema = (
	t: TranslateFunction,
	{ lockKeyFields = false }: KeyFieldsLockOptions = {},
) => {
	return z
		.object({
			name: trimmedNullable(
				z.string().max(
					ValidationLimits.TextLength.LongName,
					t(Resources.Portfolio.AddShared.Validations.maxLength, {
						max: ValidationLimits.TextLength.LongName,
					}),
				),
			),
			contractNumber: lockableField(
				trimmedNullable(
					z.string().max(
						ValidationLimits.TextLength.Name,
						t(Resources.Portfolio.AddShared.Validations.maxLength, {
							max: ValidationLimits.TextLength.Name,
						}),
					),
				),
				lockKeyFields,
			),
			producer: lockableField(
				trimmedNullable(
					z.string().max(
						ValidationLimits.TextLength.LongName,
						t(Resources.Portfolio.AddShared.Validations.maxLength, {
							max: ValidationLimits.TextLength.LongName,
						}),
					),
				),
				lockKeyFields,
			),
			product: lockableField(
				trimmedNullable(
					z.string().max(
						ValidationLimits.TextLength.LongName,
						t(Resources.Portfolio.AddShared.Validations.maxLength, {
							max: ValidationLimits.TextLength.LongName,
						}),
					),
				),
				lockKeyFields,
			),
			productCategoryId: lockableField(
				z.number().int().nullable(),
				lockKeyFields,
			),
			signedAt: lockableField(
				optionalDateAsString(DateFormat.Iso),
				lockKeyFields,
			),
			startAt: lockableField(
				optionalDateAsString(DateFormat.Iso),
				lockKeyFields,
			),
			endAt: lockableField(optionalDateAsString(DateFormat.Iso), lockKeyFields),
		})
		.superRefine(
			refineDateOrder({
				startBeforeSigned: t(
					Resources.Portfolio.AddShared.Validations.startBeforeSigned,
				),
				endBeforeSigned: t(
					Resources.Portfolio.AddShared.Validations.endBeforeSigned,
				),
				endBeforeStart: t(
					Resources.Portfolio.AddShared.Validations.endBeforeStart,
				),
			}),
		)
		.superRefine(getContractRequiredMinimumRefinement({ lockKeyFields }));
};

export type LifeInsuranceFormInput = z.input<
	ReturnType<typeof getLifeInsuranceFormSchema>
>;
export type LifeInsuranceFormOutput = z.output<
	ReturnType<typeof getLifeInsuranceFormSchema>
>;
